import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudDividerModule,
	FreudLoaderModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ModalSidebarModule } from './../../../../shared/components/modal-sidebar/modal-sidebar.module';
import { EvaluationAnswerDetailComponent } from './evaluation-answer-detail.component';

@NgModule({
	declarations: [EvaluationAnswerDetailComponent],
	imports: [
		CommonModule,
		ModalSidebarModule,
		FreudLoaderModule,
		FreudTooltipModule,
		FreudDividerModule,
		TranslateModule,
	],
	exports: [EvaluationAnswerDetailComponent],
})
export class EvaluationAnswerDetailModule {}
